import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import API, { newsUrl as NewsQK } from './api';
import { ResponseType } from 'src/constants/data';
import { NewsFiltersProps } from '../interfaces';
import { PaginationState } from 'src/types';

export const useGetInfiniteNews = (params: Partial<NewsFiltersProps> & PaginationState) => {
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: [NewsQK, ResponseType.List, JSON.stringify(params)],
    queryFn: ({ pageParam = 1 }) => API.GetNews({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil(lastPage.totalCount / params.limit);
      const currentPage = allPages.length;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    placeholderData: keepPreviousData
  });
};

export const useGetNews = (slug: string | undefined) => {
  return useQuery({
    queryKey: [NewsQK, ResponseType.Single, slug],
    queryFn: () => API.GetSingleNews(slug),
    enabled: !!slug
  });
};

export const useGetTags = () => {
  return useQuery({
    queryKey: [NewsQK, ResponseType.List],
    queryFn: API.GetTags,
    enabled: true
  });
};
